import { Route, Routes } from 'react-router-dom';
import Notification from './components/Navbar/Notification';
import PrivateAdminRoute from './components/routeProtection/PrivateAdminRoute';
import PrivateRoute from './components/routeProtection/PrivateRoute';
import PublicRoute from './components/routeProtection/PublicRoute';
import NotFound from './components/ui/NotFound';
import useAuthCheck from './hooks/useAuthCheck';
import SpinLoader from './Loader/SpinLoader';
import Assignment from './pages/admin/Assignment';
import AssignmentMark from './pages/admin/AssignmentMark';
import Dashboard from './pages/admin/Dashboard';
import Quizzes from './pages/admin/Quizzes';
import Videos from './pages/admin/Videos';
import Courses from './pages/student/Courses';
import Leaderboard from './pages/student/Leaderboard';
import QuizPage from './pages/student/QuizPage';
import StudentLogin from './pages/student/StudentLogin';
import StudentReg from './pages/student/StudentReg';

function App() {
  const authChecked = useAuthCheck();

  return !authChecked ? (
    <SpinLoader />
  ) : (
    <><Notification />
      <Routes>

        <Route path='/' element={<PublicRoute><StudentLogin /></PublicRoute>} />
        <Route path='/register' element={<PublicRoute><StudentReg /></PublicRoute>} />
        <Route path='/courses/:videoId' element={<PrivateRoute><Courses /></PrivateRoute>} />
        <Route path='/courses/quiz/:videoId' element={<PrivateRoute><QuizPage /></PrivateRoute>} />
        <Route path='/leaderboard' element={<PrivateRoute><Leaderboard /></PrivateRoute>} />

        <Route path='/admin' element={<PublicRoute><StudentLogin /></PublicRoute>} />
        <Route path='/admin/dashboard' element={<PrivateAdminRoute><Dashboard /></PrivateAdminRoute>} />
        <Route path='/admin/videos' element={<PrivateAdminRoute><Videos /></PrivateAdminRoute>} />
        <Route path='/admin/assignment' element={<PrivateAdminRoute><Assignment /></PrivateAdminRoute>} />
        <Route path='/admin/quizzes' element={<PrivateAdminRoute><Quizzes /></PrivateAdminRoute>} />
        <Route path='/admin/assignment-mark' element={<PrivateAdminRoute><AssignmentMark /></PrivateAdminRoute>} />
        <Route path='*' element={<PrivateRoute><NotFound /></PrivateRoute>} />
      </Routes>

    </>);
}

export default App;
